import createRoute   from '@widesk-ui/tools/createRoute';
import TaxonomyModel from '@models/shop/TaxonomyModel';

export default createRoute.splitView(
	'/entertainments/:entertainmentId/taxonomies',
	'shop',
	'TaxonomySplitViewTree',
	TaxonomyModel.localize('plural'),
	true,
);
